import { OptionTab } from "../../shared/ScrollNavChips";

export const PortalHeader = (props: {
  personName: string;
  logo?: string;
  tabs: OptionTab[];
  activeTab: number;
  setActiveTab: (val: number) => void;
}) => {
  return (
    <header>
      <nav className="navbar navbar-expand-sm bg-white portal-header-compact">
        <div className="container-fluid d-flex flex-row flex-nowrap align-items-center">
          {props?.logo && props.logo?.length > 0 ? (
            <img src={props.logo} alt="Logo" className="imgLogoControlWidth" />
          ) : (
            <h5 className="imgLogoControlWidth">{props.personName}</h5>
          )}
          <div className="navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-0">
              {props.tabs.map((x, i) => (
                <NavItem
                  key={i}
                  {...{
                    ...x,
                    iconActive: x.iconActive,
                    iconInactive: x.iconInactive,
                    activeTab: props.activeTab,
                    setActiveTab: props.setActiveTab
                  }}
                />
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

const NavItem = (props: OptionTab) => {
  const isActive = props.index === props.activeTab;
  const onSetActiveTab = () => props.setActiveTab(props.index);

  return (
    <li className={"nav-item pointer nav-itemO" + (isActive ? " active" : "")}>
      <div
        onClick={onSetActiveTab}
        className="nav-link nav-itemO"
        aria-current="page"
      >
        <p>{props.title}</p>
        <hr />
      </div>
    </li>
  );
};
